import script0 from './core/components/client/index.js';
import script1 from './core/connection/client/index.js';
import script2 from './core/contentType/client/index.js';
import script3 from './core/core/client/index.js';
import script4 from './core/database/client/index.js';
import script5 from './core/file/client/index.js';
import script6 from './core/pwa/client/index.js';
import script7 from './core/router/client/index.js';
import script8 from './core/session/client/index.js';
import script9 from './module/chromextension/client/index.js';
import script10 from './module/fileManager/client/index.js';
import script11 from './module/mediaqueue/client/index.js';
export default function(app) {
  script0(app);
  script1(app);
  script2(app);
  script3(app);
  script4(app);
  script5(app);
  script6(app);
  script7(app);
  script8(app);
  script9(app);
  script10(app);
  script11(app);
}
